/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { htmlspecialchars, mj_create_unique_id } from './util.js';
import { mjt } from './i18ntexts.js';
import { jQuery } from '../other/jquery-hooked.js';
import { closeDialog } from './dialog-util.js';


export function info_box( title, msg, dlg_w ) {
	var box = jQuery('#info-box');
	closeDialog(box,true);
	if( dlg_w===undefined ) dlg_w = 350;
	box
		.children('#info-box-text').html(msg).end()
		.children('#info-box-ok').prop('disabled',true).off().click(function() {
			closeDialog(box,true);
		}).end()
		.dialog( {
			classes:{'ui-dialog':'info-box'},
			title:title,
			width:dlg_w,
			modal:true,
			resizable:false,
			position:{my:'center bottom',at:'center',of:window,'collision':'flip fit'},
			open:function(ev,ui) {
				setTimeout( function() {
					jQuery('#info-box-ok').prop('disabled',false).focus();
				}, 100 );
			},
			close:function(ev,ui) {
				jQuery('#info-box-ok').prop('disabled',true);
				box.dialog('destroy');
			},
		} )
		.show();
	jQuery('div.ui-widget-overlay').click(); // hotfix: das sorgt dafuer, dass beim aufruf von startProgress() innerhalb des callbacks der hintergrund (#page-blocking-overlay) wirklich abgedunkelt wird
}


function _error_box( title, msg, list, dlg_w, html, close_cb ) {
	var ls = '';
	if( list && list.length ) {
		ls = '<div style="margin:5px 5px">';
		for( var i=0; i<list.length; ++i ) ls += '- '+htmlspecialchars(list[i])+'<br />';
		ls += '</div>';
	}
	var box = $('#error-box');
	closeDialog(box,true);
	box
		.children('#error-box-text').html(html?msg:htmlspecialchars(msg)).append(ls).end()
		.children('#error-box-ok').off().click(function() {
			if( close_cb ) {
				close_cb();
				close_cb = null;
			}
			closeDialog(box,true);
		}).end()
		.dialog( {
			classes:{'ui-dialog':'error-box'},
			title:title,
			width:dlg_w,
			modal:true,
			resizable:false,
			position:{my:'center bottom',at:'center',of:window,'collision':'flip fit'},
			close:function(ev,ui) {
				$(this).dialog('destroy');
				if( close_cb ) {
					close_cb();
					close_cb = null;
				}
			}
		} )
		.show()
	;
}

export function big_error_box(title,msg,list,html,close_cb) {
	_error_box(title,msg,list,550,html,close_cb);
}

export function error_box(title,msg,list,html,close_cb) {
	_error_box(title,msg,list,350,html,close_cb);
}


function _question_box( title, msg, question_cb, questions, dlg_w, cancel_cb ) {
	var questions_html = [];
	if( questions ) {
		for( var i=0; i < questions.length; ++i ) {
			var question = questions[i];
			var iid = mj_create_unique_id('question-box-question-');
			if( !question.key ) {
				question.key = iid;
			}
			questions_html.push( '<label for="'+iid+'">'+htmlspecialchars(question.title)+': </label>'
								+'<input id="'+iid+'" type="text" class="text" style="width:250px" name="question_inputs[]" value="'+htmlspecialchars(question.value,true,true)+'" data-key="'+htmlspecialchars(question.key,true,true)+'">' );
		}
	}
	var box = $('#question-box');
	box
		.children('#question-box-text').html(msg).end()
		.children('#question-box-inputs').html(questions_html.join('<br />')).toggle(questions_html.length>0).end()
		.children('#question-box-ok').off().click(function() {
			var question_vals = {};
			$('#question-box-inputs input').each( function() {
				question_vals[$(this).data('key')] = $(this).val();
			} );
			question_cb(question_vals);
			closeDialog( box, true );
		}).end()
		.children('#question-box-cancel').off().click(function() {
			if( cancel_cb ) cancel_cb();
			closeDialog( box, true );
		}).end()
		.dialog( {
			classes:{'ui-dialog':'question-box'},
			title:title,
			width:dlg_w,
			modal:true,
			resizable:false,
			position:{my:'center bottom',at:'center',of:window,'collision':'flip fit'},
			open:function(ev,ui) {
				setTimeout( function() {
					$('#question-box-ok').focus();
				}, 100 );
			},
			close:function(ev,ui) {
				if( cancel_cb ) cancel_cb();
				box.dialog('destroy');
			},
		} )
		.show();
	$('div.ui-widget-overlay').click(); // hotfix: das sorgt dafuer, dass beim aufruf von startProgress() innerhalb des callbacks der hintergrund (#page-blocking-overlay) wirklich abgedunkelt wird
}

export function question_box(title,msg,question_cb,questions,cancel_cb) {
	_question_box(title,msg,question_cb,questions,400,cancel_cb);
}


function _confirm_box(title,msg,confirm_cb,options,dlg_w,no_cb,cancel_cb) {
	var opts_html = [];
	if( options ) {
		for( var i=0; i<options.length; ++i ) {
			var opt=options[i], iid=mj_create_unique_id('confirm-box-option-');
			opts_html.push(  '<input type="checkbox" name="confirm_options[]" value="'+htmlspecialchars(opt.key,true,true)+'" id="'+iid+'" '+(opt.checked?'checked="checked" ':'')+'/>'
							+'<label for="'+iid+'"> '+htmlspecialchars(opt.title)+'</label>' );
		}
	}
	var yes_no_cancel = !!cancel_cb;
	var box = $('#confirm-box').toggleClass('is-yes-no-cancel',yes_no_cancel);
	closeDialog(box,true);
	var lbls = [];
	if( yes_no_cancel ) {
		lbls[0] = ' &nbsp;&nbsp; '+mjt('save')+' &nbsp;&nbsp; ';
		lbls[1] = ' &nbsp; '+mjt('dont-save')+' &nbsp; ';
		lbls[2] = ' &nbsp; '+mjt('cancel')+' &nbsp; ';
	} else {
		lbls[0] = ' &nbsp;&nbsp; '+mjt('yes')+' &nbsp;&nbsp; ';
		lbls[1] = ' &nbsp; '+mjt('no')+' &nbsp; ';
	}
	box
		.children('#confirm-box-text').html(msg).end()
		.children('#confirm-box-options').html(opts_html.join('<br />')).toggle(opts_html.length>0).end()
		.children('#confirm-box-yes').prop('disabled',true).find('.label').html(lbls[0]).end().off().click(function() {
			var opt_vals = {};
			$('#confirm-box-options input[type=checkbox]').each( function() {
				opt_vals[$(this).val()] = $(this).prop('checked');
			} );
			confirm_cb(opt_vals);
			closeDialog( box, true );
		}).end()
		.children('#confirm-box-no').prop('disabled',true).find('.label').html(lbls[1]).end().off().click(function() {
			if( no_cb ) no_cb();
			closeDialog( box, true );
		}).end()
		.children('#confirm-box-cancel').toggle(yes_no_cancel).prop('disabled',true).find('.label').html(lbls[2]).end().off().click(function() {
			if( cancel_cb ) cancel_cb();
			closeDialog( box, true );
		}).end()
		.dialog( {
			classes:{'ui-dialog':'confirm-box'},
			title:title,
			width:dlg_w,
			modal:true,
			resizable:false,
			position:{my:'center bottom',at:'center',of:window,'collision':'flip fit'},
			open:function(ev,ui) {
				setTimeout( function() {
					$('#confirm-box-yes,#confirm-box-no,#confirm-box-cancel').prop('disabled',false);
					$('#confirm-box-yes').focus();
				}, 100 );
			},
			close:function(ev,ui) {
				if( cancel_cb ) cancel_cb();
				else if( no_cb ) no_cb();
				$('#confirm-box-yes,#confirm-box-no,#confirm-box-cancel').prop('disabled',true);
				box.dialog('destroy');
			},
		} )
		.show();
	$('div.ui-widget-overlay').click(); // hotfix: das sorgt dafuer, dass beim aufruf von startProgress() innerhalb des callbacks der hintergrund (#page-blocking-overlay) wirklich abgedunkelt wird
}


export function confirm_box(title,msg,confirm_cb,options,no_cb) {
	_confirm_box(title,msg,confirm_cb,options,350,no_cb);
}

export function confirm_unsaved_close_box(title,msg,confirm_cb,options,no_cb,cancel_cb) {
	_confirm_box(title,msg,confirm_cb,options,400,no_cb,cancel_cb);
}

export function big_confirm_box(title,msg,confirm_cb,options,no_cb) {
	_confirm_box(title,msg,confirm_cb,options,550,no_cb);
}

